import Colors from '../../../../shared/assets/style/default/color';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ProgressBarRemainder = styled.div<React.CSSProperties>`
  background: ${Colors['light']};
  bottom: ${3 * Screen.widthRatio}px;
  border-radius: ${5 * Screen.widthRatio}px;
  height: ${12 * Screen.widthRatio}px;
  position: absolute;
  pointer-events: none;
  width: 100%;
`;

export default ProgressBarRemainder;
